<template>
    <div>
        <div class="warp">
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="个人资料" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                    <div class="name">姓名：</div>
                    <div class="content">{{userInfo.realName||'--'}}</div>
                </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                      <div class="name">账号：</div>
                      <div class="content">{{userInfo.username||'--'}}</div>
                  </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child" v-if="userInfo.sysRoleVoList&&userInfo.sysRoleVoList.length>0">
                        <div class="name">角色：</div>
                        <div class="content">
                          <span
                            v-for="(i,index) in userInfo.sysRoleVoList"
                            :key="index"
                            v-if="userInfo.sysRoleVoList.length==1"
                          >{{i.roleName||'--'}}</span>
                          <span
                            v-for="(i,index) in userInfo.sysRoleVoList"
                            :key="index"
                            v-if="userInfo.sysRoleVoList.length>1"
                          >{{i.roleName||'--'}}、</span>
                        </div>
                    </div>
                  </el-col>
                </el-row>
              </el-card>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            userInfo:JSON.parse(window.localStorage.getItem('userInfo'))||{},
        }
    }
}
</script>

<style lang="scss" scoped>
.box{
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>